<!--
  * @Author: changyunxia
  * @Date:2020年10月15日 15:19:14
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月15日 15:19:14
  * @Description: 选择参会人
  * @FilePath:@/components/selectParticipants.vue
-->
<template>
  <div>
    <van-cell value="选择参会人" style="boeder:0" />
    <meetingUserList :plus="true" :close="true" :user-list="userList" :show-picker.sync="showPicker" />
    <van-popup v-model="showPicker" position="bottom" style="height:100vh">
      <getNeetingUsers
        :show-picker.sync="showPicker"
        :department="switchStatus"
        :all-users="allUsers"
        :user-list="userList"
        @checkedNodes="checkedNodesFunc"
      />
    </van-popup>
  </div>

</template>

<script>
import getNeetingUsers from '@/components/MeetingReservation/getNeetingUsers'
import meetingUserList from '@/components/MeetingReservation/meetingUserList'

export default {
  name: 'SelectParticipants',
  components: { getNeetingUsers, meetingUserList },

  props: {
    departmentData: {
      type: Array,
      default: null
    },
    allUsers: {
      type: Array,
      default: null
    },
    meetingUsers: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      // 2015002,2012077
      showPicker: false,
      user: '',
      userList: [],
      department: this.departmentData,
      allUsersData: this.allUsers
    }
  },
  computed: {

    expandedKeys: function() {
      var key = []
      this.userList.forEach(element => {
        key.push(element.value)
      })
      return 1
    },
    // 计算数学
    switchStatus: function() {
      var arr = []
      if (this.allUsers !== null) {
        this.departmentData.forEach((element, i) => {
          var newArr = this.allUsers.filter(item => item.department === element.value)
          element.children = newArr
        })
        arr.push({
          text: '信维科技',
          id: 1,
          children: this.departmentData
        })
      }
      return arr
    }
  },
  watch: {
    departmentData: {
      handler(newVal) {
        this.department = newVal
      },
      deep: true
    },
    allUsers: {
      handler(newVal) {
        this.allUsersData = newVal
      },
      deep: true
    },
    meetingUsers: {
      handler(newVal) {
        this.userList = newVal
      },
      deep: true
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    checkedNodesFunc(data) {
      this.userList = data
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
/deep/.van-cell::after{
  border:0
}
</style>
